import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpProjectSource(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/source`)
    return {
        ecpProjectSource: data,
        mutateEcpProjectSource: mutate,
        isLoadingEcpProjectSource: !error && !data,
        isErrorEcpProjectSource: error
    }
}